import { displayTtcAndHtPrice } from './constants'

export const getPricingWithTaxInfo = (
  price: number,
  taxIncludedInPrice = false,
  taxRate = 0.2
) => {
  let priceHt = price
  let priceTtc = price
  if (displayTtcAndHtPrice) {
    if (taxIncludedInPrice) {
      priceHt = price / (1 + taxRate)
    } else {
      priceTtc = price * (1 + taxRate)
    }
  }
  return { priceHt, priceTtc }
}
